export enum KycReviewStatus {
  REJECTED_BY_WEBSITE = 'REJECTED_BY_WEBSITE',
  REJECTED_BY_INDUSTRY = 'REJECTED_BY_INDUSTRY',
  REJECTED_BY_DOCUMENTATION = 'REJECTED_BY_DOCUMENTATION',
}
